import { render, staticRenderFns } from "./contact-slide.vue?vue&type=template&id=3417b98d&scoped=true"
import script from "./contact-slide.vue?vue&type=script&lang=js"
export * from "./contact-slide.vue?vue&type=script&lang=js"
import style0 from "./contact-slide.vue?vue&type=style&index=0&id=3417b98d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3417b98d",
  null
  
)

export default component.exports